<template>
    <div class="d-flex align-center justify-center pa-4" style="min-height: 100vh;">
        <v-card elevation="3" width="100%">
            <v-card-title class="d-flex justify-center pt-6">
                <div class="d-flex flex-column align-center">
                    <v-img :src="logo" :width="75" draggable="false"/>
                    <v-img :src="logoText" :width="100" draggable="false"/>
                </div>
            </v-card-title>
            <v-card-title class="text-wrap">
                The SimpliGPS Driver web app has been replaced by the SimpliGPS Driver mobile app.
            </v-card-title>
            <v-card-text class="text-body-1">
                Search for "SimpliGPS Driver" in the App Store or Google Play, install it,
                and sign in with the phone number your fleet added you with.
            </v-card-text>
        </v-card>
    </div>
</template>

<script setup>
import {onMounted} from 'vue'
import logo from "@/assets/images/logo-1.png";
import logoText from "@/assets/images/logo-text.png";

// The retired driver web app kept the signed-in driver id and its push token
// under these keys.
onMounted(() => {
    try {
        localStorage.removeItem('driver_auth');
        localStorage.removeItem('driver_push_token');
    } catch {
        // Storage can be blocked; nothing to clean up then.
    }
});
</script>
